<template>
  <div
    class="border-outline-variant rounded-large @container flex w-full flex-row items-center overflow-hidden border p-4"
  >
    <div class="flex w-full flex-col">
      <div class="flex w-full flex-row items-center">
        <div class="relative">
          <BaseShapeMask shape="9-sided-cookie" :scale="1.1" class="relative z-10" animation="spin">
            <BaseMemberAvatar :member="coach" size="64" />
          </BaseShapeMask>
        </div>
        <div class="flex grow flex-col overflow-hidden pr-2 pl-4 text-ellipsis">
          <span class="text-body-medium text-on-surface-variant">
            <span>
              {{ $t('coaching.invitation.title') }}
            </span>
            ・
            <span>
              <TimeAgo class="" :date="createdAt" />
            </span>
          </span>
          <span class="text-body-large items-center">
            {{ $t('coaching.invitation.description', { firstName: coach.firstName }) }}
          </span>
        </div>
        <BaseButtonGroup class="shrink-0 self-start">
          <BaseIconButton
            icon="close"
            size="M"
            shape="round"
            width="narrow"
            color="outlined"
            @click="openDialog"
          />
          <BaseTextButton
            size="M"
            color="tonal"
            icon="check"
            @click="$emit('acceptCoachingInvitation', coach.id)"
            >{{ $t('coaching.invitation.acceptAction') }}</BaseTextButton
          >
        </BaseButtonGroup>
      </div>
    </div>
    <BaseDialog
      type="basic"
      :is-open="isOpen"
      @close="closeDialog"
      :title="$t('coaching.invitation.withdrawDialog.title')"
      :description="
        $t('coaching.invitation.withdrawDialog.description', { firstName: coach.firstName })
      "
    >
      <template #confirm
        ><BaseTextButton @click="$emit('rejectCoachingInvitation', coach.id)">{{
          $t('coaching.invitation.rejectAction')
        }}</BaseTextButton></template
      >
      <template #dismiss
        ><BaseTextButton @click="closeDialog">{{ $t('common.cancel') }}</BaseTextButton></template
      >
    </BaseDialog>
  </div>
</template>

<script setup lang="ts">
  import BaseMemberAvatar from '@/core/components/base/avatar/BaseMemberAvatar.vue'
  import BaseButtonGroup from '@/core/components/base/button/BaseButtonGroup.vue'
  import BaseIconButton from '@/core/components/base/button/icon-button/BaseIconButton.vue'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import BaseDialog from '@/core/components/base/dialog/BaseDialog.vue'
  import { useDialog } from '@/core/components/base/dialog/use-dialog'
  import BaseShapeMask from '@/core/components/base/shapes/BaseShapeMask.vue'
  import TimeAgo from '@/core/components/base/time-ago/TimeAgo.vue'
  import type { Member } from '@/core/models/member/member'

  interface Props {
    coach: Member
    createdAt: string
  }

  defineProps<Props>()

  defineEmits<{
    (e: 'acceptCoachingInvitation', coachId: string): void
    (e: 'rejectCoachingInvitation', coachId: string): void
  }>()

  const { isOpen, openDialog, closeDialog } = useDialog()
</script>
